// import React, { Component } from "react";
// import "./Job.css";
// import work from "../../../Assets/img/work.svg";
// import Header from "../../Hoc/Header";
// import Footer from "../../Hoc/Footer";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import Loader from "react-loader-spinner";
// import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
// import {
//   CollapsibleComponent,
//   CollapsibleHead,
//   CollapsibleContent,
// } from "react-collapsible-component";
// import filter from "../../../Assets/img/sort.png";
// import deletee from "../../../Assets/img/deletee.png"
// import styles from './Job.module.scss'
// import { BiTimer } from 'react-icons/bi';
// import { BsGlobe } from 'react-icons/bs';

// export default class JobList extends Component {
//   state = {
//     posts: [],
//     countrys: [],
//     country: "",
//     empty: false,
//     loader: true,
//     notFiltered:false
//   };

//   componentDidMount() {
//     this.getPosts();
//     this.getCountry();
//   }

//   getCountry() {
//     axios
//       .get(`https://arianaapp.arianaapply.com/api/V1/show-country-filter`)
//       .then((res) => {
//         console.log("country", res);
//         this.setState({ countrys: res.data });
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   }

//   delete() {
//     window.location.reload();
//   }

//   getPosts() {
//     axios
//       .get(
//         `https://arianaapp.arianaapply.com/api/V1/show-select-time-jobopportunities/${this.props.match.params.type}`
//       )
//       .then((res) => {
//         if (res.data.length === 0) {
//           this.setState({ empty: true, loader: false , notFiltered:false });
//         } else {
//           console.log("country-send", res);
//           this.setState({
//             posts: res.data,
//             empty: false,
//             loader: false,
//             notFiltered: true,
//           });
//         }
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   }

//   onChange(e) {
//     this.setState(
//       {
//         loader: true,
//         notFiltered: false,
//         [e.target.name]: e.target.value,
//         empty:false
//       },
//       () => {
//         console.log(this.state.country);
//         axios
//           .get(
//             `https://arianaapp.arianaapply.com/api/V1/show-select-country-jobopportunities/${this.state.country}/${this.props.match.params.type}`
//           )
//           .then((res) => {
//             if (res.data.length === 0) {
//               this.setState({ empty: true, loader: false , notFiltered:false });
//             } else {
//               console.log("country-send", res);
//               this.setState({
//                 posts: res.data,
//                 empty: false,
//                 loader: false,
//                 notFiltered: true,
//               });
//             }
//           })
//           .catch((err) => {
//             console.log(err);
//           });
//       }
//     );
//   }

//   renderItem(post) {
//     const oneDay = 1000 * 60 * 60 * 24;
//     const today = new Date();
//     const deadline = new Date(post.deadline.toString());
//     const differenceMs = Math.abs(today - deadline);
//     const date = Math.round(differenceMs / oneDay);
//     console.log("deadline", date);

//     return (
//       <>
//         {
//           <div className={styles.jobBodyItem}>
//           {<Link className={styles.link} to={`/single-job/${post._id}`}>
//                <div className={styles.cardImg}><img src={work} alt="" /></div>
//                <div className={styles.cardText}>
//                 <h2>{post.title_fa ? post.title_fa : post.title}</h2>
//                 <p>{post.responsibility}</p>
//                 <div className={styles.cardUnderItems}>
                 
//                   <div className={styles.cardUnderItem}><BsGlobe />{post.country}</div>
//                   <div className={styles.cardUnderItem}> <BiTimer /> {date} روز </div>
                 
                  
//                 </div>
//                </div>
//               </Link>}
//           </div>  

//         }
//       </>
//     );
//   }

//   render() {
//     const refreshPage = () => {
//       window.location.reload();
//     };
//     return (
//       <div className="pageWrapper">
//         <Header
//           title={
//             this.props.match.params.type === "accounting"
//               ? "موقعیت های حسابداری"
//               : this.props.match.params.type === "art"
//               ? "موقعیت های هنر"
//               : this.props.match.params.type === "medical"
//               ? "موقعیت های پزشکی"
//               : this.props.match.params.type === "engineering"
//               ? "موقعیت های مهندسی"
//               : this.props.match.params.type === "law"
//               ? "موقعیت های حقوق"
//               : this.props.match.params.type === "management"
//               ? "مدیریت "
//               : this.props.match.params.type === "teacher"
//               ? "معلم "
//               : this.props.match.params.type === "consultant"
//               ? "مشاور "
//               : this.props.match.params.type === "marketing"
//               ? "بازاریابی و فروش"
//               : ""
//           }
//         />

//         <div className="job-list">
//           <div className="job-list-body-r">
//             <div className="filter-body">
//               <CollapsibleComponent>
//                 <CollapsibleHead className="additionalClassForHead">
//                   فیلتر <img src={filter} alt="Portfolio" />
//                 </CollapsibleHead>

//                 <CollapsibleContent className="additionalClassForContent">
//                   <button className="delete-filter" onClick={refreshPage}>
//                     پاک کردن <img src={deletee} alt="delete" />{" "}
//                   </button>
//                   <div className="filter-select">
//                     <span>فیلتر بر اساس کشور:</span>

//                     <select
//                       className="select-country"
//                       onChange={this.onChange.bind(this)}
//                       value={this.state.country}
//                       name="country"
//                     >
//                       <option value="null">انتخاب کشور...</option>

//                       {this.state.countrys.map((post) => (
//                         <option value={post.country}>{post.country}</option>
//                       ))}
//                     </select>
//                   </div>
//                 </CollapsibleContent>
//               </CollapsibleComponent>
//             </div>

//             {this.state.notFiltered === true ? (
//               this.state.posts.map((post) => {
//                 return this.renderItem(post);
//               })
//             ) : this.state.empty === true ? (
//               <p className="not-found">نتیجه ای یافت نشد</p>
//             ) : this.state.loader === true ? (
//               <div className="spinner">
//                 <Loader
//                   type="TailSpin"
//                   color="rgb(236, 177, 28)"
//                   height={80}
//                   width={80}
//                 />
//               </div>
//             ) :   null}
//           </div>
//         </div>
//         <Footer active='job'/>
//       </div>
//     );
//   }
// }

import React, { useState, useEffect } from "react";
import "./Job.css";
import work from "../../../Assets/img/work.svg";
import Header from "../../Hoc/Header";
import Footer from "../../Hoc/Footer";
import axios from "axios";
import { Link, useParams, useLocation } from "react-router-dom";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import {
  CollapsibleComponent,
  CollapsibleHead,
  CollapsibleContent,
} from "react-collapsible-component";
import filter from "../../../Assets/img/sort.png";
import deletee from "../../../Assets/img/deletee.png";
import styles from "./Job.module.scss";
import { BiTimer } from "react-icons/bi";
import { BsGlobe } from "react-icons/bs";

function JobList() {
  const { type } = useParams(); // مثلا software_it
  const location = useLocation();

  const [posts, setPosts] = useState([]);
  const [countrys, setCountrys] = useState([]);
  const [country, setCountry] = useState("");
  const [empty, setEmpty] = useState(false);
  const [loader, setLoader] = useState(true);
  const [notFiltered, setNotFiltered] = useState(false);

  // عنوان صفحه (اگه از صفحه قبل state اومده باشه بهتره)
  const pageTitle =
    location.state?.category_fa || type || "موقعیت‌های شغلی";

  useEffect(() => {
    getPosts();
    getCountry();
  }, [type]);

  const getCountry = () => {
    axios
      .get(`https://arianaapp.arianaapply.com/api/V1/show-country-filter`)
      .then((res) => {
        const data = Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data?.data)
          ? res.data.data
          : [];
        setCountrys(data);
      })
      .catch((err) => console.log(err));
  };

  const getPosts = () => {
    setLoader(true);
    setNotFiltered(false);
    setEmpty(false);

    axios
      .get(
        `https://arianaapp.arianaapply.com/api/V1/show-select-time-jobopportunities/${type}`
      )
      .then((res) => {
        const data = Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data?.data)
          ? res.data.data
          : [];

        if (data.length === 0) {
          setEmpty(true);
          setLoader(false);
          setNotFiltered(false);
        } else {
          setPosts(data);
          setEmpty(false);
          setLoader(false);
          setNotFiltered(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
        setEmpty(true);
      });
  };

  const onChangeCountry = (e) => {
    const selectedCountry = e.target.value;
    setCountry(selectedCountry);
    setLoader(true);
    setNotFiltered(false);
    setEmpty(false);

    if (!selectedCountry || selectedCountry === "null") {
      getPosts();
      return;
    }

    axios
      .get(
        `https://arianaapp.arianaapply.com/api/V1/show-select-country-jobopportunities/${selectedCountry}/${type}`
      )
      .then((res) => {
        const data = Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data?.data)
          ? res.data.data
          : [];

        if (data.length === 0) {
          setEmpty(true);
          setLoader(false);
          setNotFiltered(false);
        } else {
          setPosts(data);
          setEmpty(false);
          setLoader(false);
          setNotFiltered(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
        setEmpty(true);
      });
  };

  const refreshPage = () => {
    window.location.reload();
  };

  const renderItem = (post) => {
    let daysLeft = "-";
    if (post.deadline) {
      const oneDay = 1000 * 60 * 60 * 24;
      const today = new Date();
      const deadline = new Date(post.deadline.toString());
      const differenceMs = Math.abs(today - deadline);
      daysLeft = Math.round(differenceMs / oneDay);
    }

    return (
      <div className={styles.jobBodyItem} key={post._id}>
        <Link className={styles.link} to={`/single-job/${post._id}`}>
          <div className={styles.cardImg}>
            <img src={work} alt="" />
          </div>
          <div className={styles.cardText}>
            <h2>{post.title_fa ? post.title_fa : post.title}</h2>
            <p>{post.responsibility}</p>
            <div className={styles.cardUnderItems}>
              <div className={styles.cardUnderItem}>
                <BsGlobe />
                {post.country}
              </div>
              <div className={styles.cardUnderItem}>
                <BiTimer /> {daysLeft} روز
              </div>
            </div>
          </div>
        </Link>
      </div>
    );
  };

  return (
    <div className="pageWrapper">
      <Header title={pageTitle} />

      <div className="job-list">
        <div className="job-list-body-r">
          <div className="filter-body">
            <CollapsibleComponent>
              <CollapsibleHead className="additionalClassForHead">
                فیلتر <img src={filter} alt="Portfolio" />
              </CollapsibleHead>

              <CollapsibleContent className="additionalClassForContent">
                <button className="delete-filter" onClick={refreshPage}>
                  پاک کردن <img src={deletee} alt="delete" />
                </button>
                <div className="filter-select">
                  <span>فیلتر بر اساس کشور:</span>
                  <select
                    className="select-country"
                    onChange={onChangeCountry}
                    value={country}
                    name="country"
                  >
                    <option value="null">انتخاب کشور...</option>
                    {countrys.map((item, index) => (
                      <option key={index} value={item.country}>
                        {item.country}
                      </option>
                    ))}
                  </select>
                </div>
              </CollapsibleContent>
            </CollapsibleComponent>
          </div>

          {loader ? (
            <div className="spinner">
              <Loader
                type="TailSpin"
                color="rgb(236, 177, 28)"
                height={80}
                width={80}
              />
            </div>
          ) : empty ? (
            <p className="not-found">نتیجه‌ای یافت نشد</p>
          ) : notFiltered ? (
            posts.map((post) => renderItem(post))
          ) : null}
        </div>
      </div>

      <Footer active="job" />
    </div>
  );
}

export default JobList;